/**
 * Versement mensuel (prêt amortissable canadien, capitalisation semestrielle).
 * @param {number} principal - Capital restant
 * @param {number} annualRateDecimal - Taux nominal annuel (ex. 0.055 pour 5,5 %)
 * @param {number} numPayments - Nombre de paiements mensuels restants
 */
export function monthlyPaymentCanadianAmortizing(principal, annualRateDecimal, numPayments) {
  const r = annualRateDecimal;
  const monthlyMortgageRate = Math.pow(1 + r / 2, 1 / 6) - 1;
  if (principal <= 0 || numPayments <= 0 || monthlyMortgageRate <= 0) return 0;
  return (
    (principal *
      (monthlyMortgageRate * Math.pow(1 + monthlyMortgageRate, numPayments))) /
    (Math.pow(1 + monthlyMortgageRate, numPayments) - 1)
  );
}

/**
 * Nombre de paiements mensuels restants (inverse amortissement canadien).
 * Retourne null si le versement couvre tout au plus les intérêts (pas d’amortissement fini).
 *
 * @param {number} principal - Capital restant
 * @param {number} annualRateDecimal - Taux nominal annuel (ex. 0.055)
 * @param {number} monthlyPayment - Versement mensuel
 * @returns {number|null} - Nombre de mois (fractionnaire); null si invalide
 */
export function remainingMonthsFromPaymentCanadianAmortizing(
  principal,
  annualRateDecimal,
  monthlyPayment,
) {
  const r = annualRateDecimal;
  const i = Math.pow(1 + r / 2, 1 / 6) - 1;
  if (principal <= 0 || monthlyPayment <= 0 || i <= 0) return null;
  const interestOnly = principal * i;
  if (monthlyPayment <= interestOnly + 1e-12) return null;
  const ratio = monthlyPayment / (monthlyPayment - principal * i);
  if (ratio <= 1) return null;
  return Math.log(ratio) / Math.log(1 + i);
}
